/* eslint-disable */
import * as Types from '../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUsersCountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUsersCountQuery = { __typename: 'Query', listUsers: { __typename: 'UserResponse', total: string | null } };


export const GetUsersCountDocument = gql`
    query getUsersCount {
  listUsers {
    total
  }
}
    `;

/**
 * __useGetUsersCountQuery__
 *
 * To run a query within a React component, call `useGetUsersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersCountQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersCountQuery, GetUsersCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersCountQuery, GetUsersCountQueryVariables>(GetUsersCountDocument, options);
      }
export function useGetUsersCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersCountQuery, GetUsersCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersCountQuery, GetUsersCountQueryVariables>(GetUsersCountDocument, options);
        }
export type GetUsersCountQueryHookResult = ReturnType<typeof useGetUsersCountQuery>;
export type GetUsersCountLazyQueryHookResult = ReturnType<typeof useGetUsersCountLazyQuery>;